<ng-container *transloco="let t; read: 'user'">
  <div class="rounded-lg fixActionRow">
    <div class="flex justify-between border-b">
      <h1 class="text-[25px] font-bold">{{title}}</h1>
      <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
    </div>

    <div mat-dialog-content>
      <form class="grid grid-cols-2 gap-4 gap-x-10 mt-2 pb-3 w-[100%]" [formGroup]="enrollmentForm">

        <div class="select-input flex-col justify-center items-center">
          <drdp-select-state
            [initialStateId]="stateId.value"
            (state)="handleDropdown($event, selectType.States)"
            [isValid]="!stateId.touched || stateId.valid"
            [required]="true">
          </drdp-select-state>
        </div>

        <div class="col-span-1 items-center w-[100%]">
          <drdp-select-agency
            [initialAgencyId]="agencyId.value"
            (agency)="handleDropdown($event, selectType.Agencies)"
            [stateId]="stateId.value"
            [required]="true"
            >
          </drdp-select-agency>
        </div>

        <div class="col-span-1 items-center w-[100%]">
          <drdp-select-age-grade
            #ageGroupInstrumentSelect
            [initialageGradeId]="ageGradeId.value"
            (ageGrade)="handleDropdown($event, selectType.AgeInstrument)"
            [stateId]="stateId.value"
            [multiSelect]="false"
            [required]="true"
            [label]="t('addNewChild.common.childAgeGradeInstrument')"
            [includePilot]="true"
            >
          </drdp-select-age-grade>
        </div>

        <div class="col-span-1 items-center w-[100%]">
          <drdp-date-picker
            [label]="t('addNewChild.common.agencyEnrollmentDate')"
            [initialDate]="enrollmentStartDate?.value"
            [isReadOnly]="false"
            [isRequired]="true"
            (emitDate)="handleDate($event, 'enrollmentStartDate')"
            >
          </drdp-date-picker>
        </div>

        <div class="col-span-1 items-center w-[100%]">
          <drdp-select-site
            [initialSiteId]="siteId.value"
            (site)="handleDropdown($event, selectType.Sites)"
            [agencyId]="agencyId.value"
            [multiSelect]="false"
            [multiSelectInitVals]="false"
            [required]="true"
            [isDualEnrollments]="true"
            >
          </drdp-select-site>
        </div>

        <div class="col-span-1 items-center w-[100%]">
          <drdp-select-rating-period
            [initialRatingPeriodId]="ratingPeriodId.value"
            (ratingPeriod)="handleDropdown($event, selectType.RatingPeriods)"
            [agencyId]="agencyId.value"
            [required]="true"
            [displayCurrentRps]="true">
          </drdp-select-rating-period>
        </div>

        <div class="col-span-1 items-center w-[100%]">
          <drdp-select-class
            (classroom)="handleDropdown($event, selectType.Class)"
            [siteIds]="siteId.value"
            [required]="true"
            [ratingPeriodId]="ratingPeriodId.value"
            [multiSelect]="false">
          </drdp-select-class>
        </div>

        <div class="col-span-1 items-center w-[100%]">
          <div class="form-input-label-group">
            <label class="font-normal required" for="enrollmentPrograms"
              >{{ t('addNewChild.common.programType') }}</label
              >
              <mat-form-field appearance="fill" class="drdp-input">
                <mat-select
                  formControlName="enrollmentProgramIds"
                  [placeholder]="enrollmentProgramPlaceholder"
                  multiple
                  required="true"
                  [disabled]="!enrollmentProgramTypesFiltered"
                  >
                  @for (ept of enrollmentProgramTypesFiltered; track ept) {
                    <!-- Server-supplied enrollment program name: not translated. -->
                    <mat-option
                      [value]="ept.enrollmentProgramId"
                      >
                      {{ ept.enrollmentProgramType?.enrollmentProgramName }}
                    </mat-option>
                  }
                </mat-select>
                @if (enrollmentProgramIds.invalid) {
                  <mat-error
                    >{{ t('addNewChild.dualEnroll.programTypeError') }}</mat-error
                    >
                  }
                </mat-form-field>
              </div>
            </div>

            <div class="col-span-1 items-center w-[100%]">
              <drdp-select-iep-plan
                [initialId]="iep.value"
                [required]="true"
                (optionSelected)="handleDropdown($event, selectType.IepPlan)"
                >
              </drdp-select-iep-plan>
            </div>

            @if (!isNewHampshire) {
              <div class="col-span-1 items-center w-[100%]">
                <drdp-select-selpa
                  (selpa)="handleDropdown($event, selectType.Selpa)"
                  additionalClasses="pb-7"
                  [initialSelpaId]="selpaId.value"
                  >
                </drdp-select-selpa>
              </div>
            }

            @if (isNewHampshire) {
              <div class="col-span-1 items-center w-[100%]">
                <label class="font-normal" [ngClass]="{'mb-7': isNewHampshire}" for="primaryDisabilityId">{{ t('addNewChild.common.primaryDisability') }}</label>
                <mat-form-field appearance="fill" class="drdp-input">
                  <mat-select
                    formControlName="primaryDisabilityId"
                    [placeholder]="selectedDisability ?? t('addNewChild.common.primaryDisability')"
                    (selectionChange)="handlePrimaryDisability($event)"
                    >
                    @for (disability of disabilities; track disability) {
                      <!-- Server-supplied disability name: not translated. -->
                      <mat-option
                        [value]="disability"
                        >{{ disability.primaryDisabilityName }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }

            @if (hasFollowUp) {
              <div class="form-input-label-group">
                <div class="col-span-1 col-end-3">
                  <label class="font-normal" for="extensiveSupportId">{{ t('addNewChild.common.extensiveSupportNeeds') }}</label>
                  <mat-radio-group
                    [attr.aria-label]="t('addNewChild.common.selectAnOption')"
                    formControlName="extensiveSupportId"
                    >
                    @for (es of extensiveSupports; track es) {
                      <!-- Server-supplied extensive support option: not translated. -->
                      <mat-radio-button
                        color="primary"
                        [value]="es.id"
                        >
                        {{ es.extensiveSupportOption }}
                      </mat-radio-button>
                    }
                  </mat-radio-group>
                </div>
              </div>
            }

            <div class="col-span-1 items-center w-[100%]">
              <label class="font-normal" for="adaptations">{{ t('addNewChild.common.adaptations') }}</label>
              <mat-form-field appearance="fill" class="drdp-input">
                <mat-select
                  formControlName="adaptationIds"
                  multiple
                  [placeholder]="t('addNewChild.common.chooseAllThatApply')"
                  >
                  @for (adaptation of adaptations; track adaptation) {
                    <!-- Server-supplied adaptation name: not translated. -->
                    <mat-option
                      [value]="adaptation.id"
                      >{{ adaptation.adaptationTypeName }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            @if (isNewHampshire) {
              <div class="col-span-1 items-center w-[100%]">
                <label class="font-normal" for="districtOfLiabilityId"
                  [ngClass]="{'required': iep.value == iepPlan.Yes}">
                  {{ t('addNewChild.common.districtOfLiability') }}
                </label>
                <mat-form-field appearance="fill" class="drdp-input">
                  <mat-select formControlName="districtOfLiabilityId" [placeholder]="t('addNewChild.common.districtOfLiability')">
                    @for (dol of districtsOfLiability; track dol) {
                      <!-- Server-supplied district of liability name: not translated. -->
                      <mat-option [value]="dol.id">
                        {{ dol.districtOfLiabilityName }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }

            @if (isNewHampshire) {
              <div class="col-span-1 items-center w-[100%]">
                <drdp-date-picker
                  [label]="t('addNewChild.common.seEntryDate')"
                  [isReadOnly]="false"
                  labelClasses="mb-2"
                  (emitDate)="handleDate($event, 'seEntryDate')"
                  >
                </drdp-date-picker>
              </div>
            }

            @if (isNewHampshire) {
              <div class="col-span-1 items-center w-[100%]">
                <drdp-date-picker
                  [label]="t('addNewChild.common.seAnticipatedExitDate')"
                  [isReadOnly]="false"
                  labelClasses="mb-2"
                  (emitDate)="handleDate($event, 'seAnticipateExitDate')"
                  >
                </drdp-date-picker>
              </div>
            }

            @if (isNewHampshire) {
              <div class="col-span-1 items-center w-[100%]">
                <drdp-select-initial-assessment-tool-type
                  additionalClasses="pb-0"
                  [label]="t('addNewChild.common.initialAssessmentTool')"
                  (optionSelected)="handleDropdown($event, 'initialAssessmentToolType')">
                </drdp-select-initial-assessment-tool-type>
              </div>
            }

            @if (isNewHampshire) {
              <div class="col-span-1 items-center w-[100%]">
                <drdp-select-outcome
                  [label]="t('addNewChild.common.outcome1')"
                  (optionSelected)="handleDropdown($event, 'outcome1')">
                </drdp-select-outcome>
              </div>
            }

            @if (isNewHampshire) {
              <div class="col-span-1 items-center w-[100%]">
                <drdp-select-outcome
                  [label]="t('addNewChild.common.outcome2')"
                  (optionSelected)="handleDropdown($event, 'outcome2')">
                </drdp-select-outcome>
              </div>
            }

            @if (isNewHampshire) {
              <div class="col-span-1 items-center w-[100%]">
                <drdp-select-outcome
                  [label]="t('addNewChild.common.outcome3')"
                  (optionSelected)="handleDropdown($event, 'outcome3')">
                </drdp-select-outcome>
              </div>
            }
          </form>

        </div>
        <div class="spacer"></div>
        <div mat-dialog-actions class="flex justify-end align-bottom">
          <drdp-btn color="cancel" class="mr-2" mat-button mat-dialog-close (click)="cancel()">{{ t('addNewChild.common.cancel') }}</drdp-btn>
          <drdp-btn mat-button [disabled]="enrollmentForm.invalid || isProcessing" cdkFocusInitial
          (click)="onSubmit()">{{ submitBtnText }}</drdp-btn>
        </div>
      </div>
</ng-container>
